import classNames from 'classnames'
import { motion } from 'framer-motion'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { Text } from '@ds'
import {
  AppLanguage,
  useAvailableQuestsActions,
  useGameSettingsActions,
} from '@store'

import styles from './LangToggle.module.scss'

export const LangToggle = () => {
  const { changeLanguage } = useGameSettingsActions()
  const { setIsLanguageSelection } = useAvailableQuestsActions()
  const { t, i18n } = useTranslation()
  const language = i18n.language

  const handleLanguageClick = useCallback(
    (lang: AppLanguage) => {
      if (language === lang) {
        setIsLanguageSelection(true)
        return
      }
      changeLanguage(lang)
      setIsLanguageSelection(true)
    },
    [language, changeLanguage, setIsLanguageSelection]
  )

  return (
    <div className={styles.localeToggle}>
      <motion.div
        className={styles.toggleIndicator}
        layout
        transition={{ type: 'spring', stiffness: 300, damping: 25 }}
        style={{ left: language === AppLanguage.RU ? '3%' : '55%' }}
      />
      <div
        className={classNames(styles.toggleOption, {
          [styles.active]: language === AppLanguage.RU,
        })}
        onClick={() => handleLanguageClick(AppLanguage.RU)}
      >
        <Text type="h1" className={styles.langText} center>
          {t('settings.ru')}
        </Text>
      </div>
      <div
        className={classNames(styles.toggleOption, {
          [styles.active]: language === AppLanguage.EN,
        })}
        onClick={() => handleLanguageClick(AppLanguage.EN)}
      >
        <Text type="h1" className={styles.langText} center>
          {t('settings.en')}
        </Text>
      </div>
    </div>
  )
}
